interface UserInfoProps {
  firstName: string;
  lastName: string;
  fullName: string;
}

export const UserInfo = ({ firstName, lastName, fullName }: UserInfoProps) => {
  const initials = firstName[0]?.toUpperCase() + lastName[0]?.toUpperCase();

  return (
    <div className="flex items-center">
      <span className="mr-sm size-lg rounded-full text-center text-body-xs leading-6 bg-level-05">
        {initials}
      </span>
      <span className="text-default">{fullName}</span>
    </div>
  );
};

UserInfo.displayName = 'UserInfo';
